import authRepository from '../repositories/auth.repository';
import roundRepository from '../repositories/round.repository';
import handleErrors from '../utils/handleErrors';
import repo from '../repositories/repo'

export default {
    async login({
        commit
    }, payload) {
        const ar = {
            ...authRepository
        };
        try {

            const {
                data: {
                    status,
                    msg,
                    user
                }
            } = await ar.login(payload.username, payload.password)

            if (!status) {

                toastr.error(msg);
                return null;
            }

            commit('user', user);

            return user;
        } catch (err) {
            toastr.error(err.response.data.message);
            return null;
        }
    },
    async getAssignations({
        state,
        commit
    }) {
        const rr = {
            ...roundRepository
        };

        try {
            const {
                data
            } = await rr.getAssignations(state.user.id);
            commit('rounds', data);
        } catch (err) {
            toastr.error(`Ocurrió un error al cargar las asignaciones [${err.message}]`);
        }
    },
    async getRounds({
        commit
    }, payload) {
        const rr = {
            ...roundRepository
        };
        try {
            const {
                data
            } = await rr.get(payload);
            commit('rounds', data);
            return true;
        } catch (err) {
            toastr.error(err.message);
            return false;
        }
    },
    async startRound(store, round) {
        const rr = {
            ...roundRepository
        };
        try {
            const {
                data
            } = await rr.startRound(round);
            return data;
        } catch (err) {
            toastr.error(err.message);
        }
    },
    async getChecklistAnswers({
        commit
    }) {
        const rr = {
            ...roundRepository
        };
        try {
            const {
                data
            } = await rr.getChecklistAnswers();
            commit('checklistAnswers', data);
            return data;
        } catch (err) {
            toastr.error(err.message);
        }
    },
    /**
     *
     * @param {commit} commit del store
     * @param {FormData} round ronda actual en formato formData
     */
    async finishRound({
        commit
    }, round) {
        const rr = {
            ...roundRepository
        };
        try {
            const {
                data
            } = await rr.finishRound(round);
            return data;
        } catch (err) {
            toastr.error(err.message);
            return null;
        }
    },
    logout({
        commit
    }) {
        commit('clearState');
        localStorage.clear();
    },
    loadRoundInProgress({
        state,
        commit
    }) {
        if (!state.roundInProgress || Object.keys(state.roundInProgress).length === 0 || !state
            .roundInProgress.startDate) {
            if (!!localStorage.getItem('bitacorapp_round_in_progress')) {
                const roundInstance = JSON.parse(localStorage.getItem(
                    'bitacorapp_round_in_progress'));
                if (roundInstance.userId === state.user.id) {
                    commit('roundInProgress', roundInstance);
                    commit('currentRound', roundInstance.currentRound);
                    commit('client', roundInstance.currentRound.client);
                }
            }
        }
    },
    async loadLastRounds({
        state,
        commit
    }) {
        const rr = {
            ...roundRepository
        };
        try {
            const {
                data
            } = await rr.getLastestRounds(state.user.id);
            const lastRounds = data.map(item => ({
                ...item,
                duration: !!item.end_date ? Math.round(moment.duration(moment(item
                    .end_date).diff(item.start_date)).as('minutes')) : ' - '
            }));
            commit('lastRounds', lastRounds);
        } catch (err) {
            handleErrors(err);
        }
    },
    loadOpenRounds({
        state,
        commit
    }) {
        repo.get('rounds/open', {
                userId: state.user.id
            })
            .then(({
                data
            }) => commit('openRounds', data))
    }
};
